import { render, staticRenderFns } from "./addMessage.vue?vue&type=template&id=5d780c39&scoped=true&"
import script from "./addMessage.vue?vue&type=script&lang=js&"
export * from "./addMessage.vue?vue&type=script&lang=js&"
import style0 from "./addMessage.vue?vue&type=style&index=0&id=5d780c39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d780c39",
  null
  
)

export default component.exports